import { ICountryDetails } from '../interfaces/country-details.interface';
import { ICountryInfo } from '../interfaces/country-info.interface';

import { CountryDetails } from './country-details.model';

export class CountryInfo {
  private countries: ICountryInfo = {};

  constructor(initialData: ICountryInfo = {}) {
    this.countries = initialData;
  }

  getCountryDetails(placeId: string): CountryDetails {
    return new CountryDetails(this.countries[placeId]);
  }

  addCountry(countryDetails: ICountryDetails): void {
    this.countries[countryDetails.place_id] = countryDetails;
  }

  removeCountry(placeId: string): void {
    delete this.countries[placeId];
  }

  getFirstCountry(): CountryDetails {
    const firstKey = Object.keys(this.countries)[0];
    return firstKey
      ? new CountryDetails(this.countries[firstKey])
      : new CountryDetails();
  }
}
